import { Route, Routes } from 'react-router-dom';
import LabsPage from '@/labs/LabsPage';
import LabsNotFoundPage from '@/labs/LabsNotFoundPage';

/** The Travo Labs page at `/`, and the 404 for every unknown URL outside /travo and /membersheep. */
const LabsSection = () => (
  <Routes>
    <Route path="/" element={<LabsPage />} />
    <Route path="*" element={<LabsNotFoundPage />} />
  </Routes>
);

export default LabsSection;
